export const frameWithTitle = [ 'tit_pic_xText', 'tit_pic_xIconText'];
export const frameWithPicture = [ 'tit_pic_xText', 'tit_pic_xIconText'];
export const maxWidth = 200;